var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "share-files" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "fixed-line clearfix",
          class: { show: _vm.files.length > 0 }
        },
        [
          _c("div", { staticClass: "fixed-left" }, [
            _c("div", { staticClass: "share-message" }, [
              _c("span", { staticClass: "share-text year" }, [
                _vm._v(_vm._s(_vm.year) + " ")
              ]),
              _vm._v(" "),
              _vm.lang === "en"
                ? _c("span", { staticClass: "share-text detail" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.month) +
                        " " +
                        _vm._s(_vm.day) +
                        " " +
                        _vm._s(_vm.$t("share.shared") + _vm.userName) +
                        "\n        "
                    )
                  ])
                : _vm.lang === "ru_RU"
                ? _c("span", { staticClass: "share-text detail" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.month) +
                        " " +
                        _vm._s(_vm.day) +
                        " " +
                        _vm._s(_vm.$t("share.shared") + _vm.userName) +
                        "\n        "
                    )
                  ])
                : _c("span", { staticClass: "share-text detail" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.month) +
                        "月" +
                        _vm._s(_vm.day) +
                        "日" +
                        _vm._s(_vm.userName) +
                        "分享的文件\n        "
                    )
                  ]),
              _vm._v(" "),
              _c("div", { staticClass: "checkbox-wrapper" }, [
                _c("div", {
                  staticClass: "checkbox",
                  class: {
                    show: _vm.selectedNum > 0 || _vm.fileOver,
                    selected: _vm.selectedNum == _vm.files.length
                  },
                  on: { click: _vm.selectAll }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "download-wrapper" }, [
                _c("i", {
                  staticClass: "icon-download",
                  class: { show: _vm.selectedNum > 0 },
                  on: { click: _vm.downloadImages }
                })
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "total-item" }, [
            _vm._v(
              _vm._s(_vm.$t("list.total")) +
                " " +
                _vm._s(_vm.files.length) +
                " " +
                _vm._s(_vm.$t("list.items"))
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "file-list view-content",
          on: {
            mouseover: function($event) {
              return _vm.fileAreaEnter(true)
            },
            mouseleave: function($event) {
              return _vm.fileAreaEnter(false)
            }
          }
        },
        _vm._l(_vm.files, function(file, fileIndex) {
          return _c(
            "div",
            {
              key: file.id,
              staticClass: "view-item folder-item",
              class: { selected: file.selected }
            },
            [
              _c("div", { staticClass: "wrapper" }, [
                _c(
                  "div",
                  {
                    staticClass: "img-file",
                    style: {
                      width: file.showWidth + "px",
                      height: file.showHeight + "px"
                    }
                  },
                  [
                    _c("img", {
                      directives: [
                        {
                          name: "lazy",
                          rawName: "v-lazy",
                          value: file.smallUrl,
                          expression: "file.smallUrl"
                        }
                      ],
                      attrs: { alt: "" },
                      on: {
                        click: function($event) {
                          return _vm.showImage(fileIndex)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "checkbox",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.fileCheckboxClick(fileIndex)
                        }
                      }
                    })
                  ]
                )
              ])
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.showProcessBar
        ? _c("process-bar", {
            attrs: { percentage: _vm.packageProcess, text: _vm.loadingText }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("share-player", {
        ref: "player",
        attrs: {
          show: _vm.playerShow,
          images: _vm.swiperImages,
          allIndex: _vm.playerStartIndex
        },
        on: {
          closeButtonClick: _vm.closeImagePlayer,
          reloadPlayerData: function($event) {
            return _vm.resetPlayerData(arguments[0])
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "list-head" }, [
      _c("div", { staticClass: "header-wrap header-public clearfix" }, [
        _c("div", { staticClass: "header-left cleearfix" }, [
          _c("i", { staticClass: "icon-czur-logo" })
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2316daa8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2316daa8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notebook/ShareFiles.vue
// module id = null
// module chunks = 